import { useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import UsageTracker from '../../../utils/UsageTracker';
import { useLessonPreQuizSession } from '../hooks/useLessonPreQuiz.migrated';
import { getPreAssessmentTrackingProps, isPreAssessmentCompleted } from '../utils/preAssessmentQuizUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LessonPreQuizAlert = ({
  lesson,
  onClick,
  screen,
  track
}) => {
  const [isDismissed, setIsDismissed] = useState(false);
  const {
    getLessonPreQuizState
  } = useLessonPreQuizSession();
  const preQuizState = getLessonPreQuizState(lesson.id);
  const isPreAssessmentCompletedFlag = !!(preQuizState && isPreAssessmentCompleted(preQuizState));
  const {
    interactionProps
  } = useMemo(() => getPreAssessmentTrackingProps({
    lesson,
    track,
    screen
  }), [lesson, track, screen]);
  const handleClick = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, interactionProps, {
      action: 'ai-pre-assessment-alert-clicked'
    }));
    onClick();
  };
  const handleClose = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, interactionProps, {
      action: 'ai-pre-assessment-alert-dismissed'
    }));
    setIsDismissed(true);
  };
  if (isDismissed) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    closeable: true,
    marginBlockEnd: "600",
    onClose: handleClose,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.preAssessmentQuiz.alert.title"
    }),
    type: "info",
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx("span", {
        children: isPreAssessmentCompletedFlag ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.preAssessmentQuiz.alert.description.completed"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.preAssessmentQuiz.alert.description.start"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleClick,
        size: "extra-small",
        use: "secondary",
        children: isPreAssessmentCompletedFlag ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.preAssessmentQuiz.alert.confirmButton.completed"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.preAssessmentQuiz.alert.confirmButton.start"
        })
      })]
    })
  });
};